import type { Dimension, IndustryBenchmark, Research } from '@/api/types';

import { DimensionRadar } from '../DimensionRadar';
import { radarAxes } from './scoring';

function BenchmarkLegend({ benchmark, benchmarkLabel }: { benchmark: IndustryBenchmark | null; benchmarkLabel: string | null }) {
  if (!benchmark) {
    return (
      <li className="dim-legend-none" title="Fewer than 3 other scored ideas share its industry">
        No industry average yet
      </li>
    );
  }
  return (
    <li title={`Mean of the ${benchmark.idea_count} other active, scored ideas in ${benchmark.industry_name}`}>
      <span className="dim-key dim-key-benchmark" aria-hidden="true" />
      {benchmarkLabel} <b>{benchmark.idea_count}</b>
    </li>
  );
}

/** The run's profile: a radar against the industry average, its legend under it. Not drawn below three scored dimensions. */
export function DimensionChart({ research, dimensions, benchmark }: { research: Research; dimensions: Dimension[]; benchmark: IndustryBenchmark | null }) {
  const axes = radarAxes(research, dimensions, benchmark);
  if (axes.length < 3) return null;
  const benchmarkLabel = benchmark ? `${benchmark.industry_name} average` : null;
  return (
    <section className="metric-tile usage-card idea-tile-chart" aria-label="Dimension profile">
      <div className="usage-card-head">
        <span className="usage-card-of">Profile</span>
      </div>
      <DimensionRadar axes={axes} benchmarkLabel={benchmarkLabel} />
      <ul className="usage-legend dim-legend">
        <li>
          <span className="dim-key dim-key-idea" aria-hidden="true" />
          This idea
        </li>
        <BenchmarkLegend benchmark={benchmark} benchmarkLabel={benchmarkLabel} />
      </ul>
    </section>
  );
}
